import { redirect } from 'shared/helpers/redirect';

export const handleForSaleLandingRouting = (url: string) => {
    const isForSaleLanding = url === '/for-sale/';

    if (isForSaleLanding) {
        redirect(url);
    }
};
